export default {"src":"/_next/static/media/download.2e64dc23.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};